module.exports = __webpack_public_path__ + "856a0725a1a85a77a64d8eeff26ae8c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/HOME.jpg
// module id = 633
// module chunks = 0